import * as types from '../constants/coreConstants';
import * as authConstants from '../../auth/constants/authConstants';

const initialState = {
  uiState: types.UI_STATES.INITIAL,
  serviceDeskContactNumber: '',
  merchantInfo: null,
  ajaxCallCount: 0,
  features: {},
  featuresLoaded: false,
  settings: {}
};

export default function Core(state = initialState, action) {
  switch (action.type) {
    case types.UPDATE_UI_STATE:
      return Object.assign({}, state, { uiState: action.response });
    case types.GET_CONTACT_INFO_SUCCCESS:
      return Object.assign({}, state, { serviceDeskContactNumber: action.response });
    case types.GET_MERCHANT_INFO_SUCCCESS:
      return Object.assign({}, state, { merchantInfo: action.response });
    case types.GET_FEATURES:
      return Object.assign({}, state, { featuresLoaded: false });
    case types.GET_FEATURES_SUCCESS:
      return Object.assign({}, state, { features: action.response, featuresLoaded: true });
    case authConstants.LOGOUT_SUCCESS:
      return Object.assign({}, state, { merchantInfo: null });
    case types.BEGIN_AJAX_CALL:
      return Object.assign({}, state, { ajaxCallCount: state.ajaxCallCount + 1 });
    case types.END_AJAX_CALL:
      return Object.assign({}, state, { ajaxCallCount: state.ajaxCallCount - 1 });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/core/reducers/core.js